import angular from 'angular';


export default function EditAlertRecipientDialogController(
  $q,
  $scope,
  ssDialogService,
  orgDataService,
  loaderService
) {
  const vm = this;

  vm.newAlertRecipient = { ...vm.alertRecipient };
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditAlertRecipientFormSubmit = _handleEditAlertRecipientFormSubmit;

  function _handleCloseDialog() {
    return _closeDialog();
  }

  function _handleEditAlertRecipientFormSubmit() {
    if ($scope.editAlertRecipientForm.$valid) {
      loaderService.showViewLoader = true;
      orgDataService.saveAlertRecipient(vm.newAlertRecipient)
        .then((response) => {
          loaderService.showViewLoader = false;
          const isNew = vm.newAlertRecipient.alertRecipientId < 0;

          angular.extend(vm.newAlertRecipient, response.data);
          angular.extend(vm.alertRecipient, vm.newAlertRecipient);
          if (isNew) {
            vm.addCallback(vm.alertRecipient);
          }
          return _closeDialog();
        });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editAlertRecipientDialog);
  }
}

EditAlertRecipientDialogController.$inject = [
  '$q',
  '$scope',
  'ssDialogService',
  'orgDataService',
  'loaderService'
];
